export const gulzhaina = {
  id: 'gulzhaina',
  name: {
    ru: 'Гульжайна Санкей',
    kz: 'Гүлжайна Санкей',
  },
  position: {
    ru: 'Врач-невропатолог',
    kz: 'Невропатолог дәрігер',
  },
  department: 'specialists',
  image: '/team_photoes/new/gulzhaina.jpeg',
  experience: {
    ru: 'Более 20 лет',
    kz: '20 жылдан астам',
  },
  education: {
    ru: `1999–2005 — Казахская государственная медицинская академия, специальность «Лечебное дело»
2005–2006 — Интернатура по специальности «Врач-терапевт»
2011 — Первичная специализация «Невропатология» (АГИУВ)`,
    kz: `1999–2005 — Қазақ мемлекеттік медицина академиясы, «Емдеу ісі» мамандығы
2005–2006 — «Дәрігер-терапевт» мамандығы бойынша интернатура
2011 — «Невропатология» бойынша алғашқы мамандандыру (АГИУВ)`,
  },
  work: {
    ru: `• 2006–2011 — Врач скорой медицинской помощи, ГССМП
- 2011–2016 — Врач-невропатолог, Городская поликлиника №8
- 2016–2020 — Врач-невропатолог, Центр медицины катастроф МЧС РК
- 2020–2022 — Врач скорой медицинской помощи, ГССМП
- 2021 — по настоящее время — Врач-невропатолог, КГУ «Коррекционная школа-интернат №1»
- 2025 — по настоящее время — Врач-невропатолог, Спортивный медицинский центр города Астана`,
    kz: `• 2006–2011 — Жедел медициналық жәрдем дәрігері, ГССМП
- 2011–2016 — Невропатолог дәрігер, №8 қалалық емхана
- 2016–2020 — Невропатолог дәрігер, ҚР ТЖМ Апаттар медицинасы орталығы
- 2020–2022 — Жедел медициналық жәрдем дәрігері, ГССМП
- 2021 — қазіргі уақытқа дейін — Невропатолог дәрігер, «№1 түзету интернат-мектебі» КМҚ
- 2025 — қазіргі уақытқа дейін — Невропатолог дәрігер, Астана қаласының спорттық медициналық орталығы`,
  },
  certificates: {
    ru: `Сертификаты и квалификация:
- Сертификат специалиста по специальности «Детская неврология» (до 2031 г.)
- Сертификат специалиста по специальности «Неврология (взрослая)» (до 2030 г.)
- Высшая квалификационная категория по специальности «Неврология (взрослая)» (до 2030 г.)
- Вторая квалификационная категория по специальности «Неврология (детская)» (до 2030 г.)`,
    kz: `Сертификаттар және біліктілік:
- «Балалар неврологиясы» мамандығы бойынша маман сертификаты (2031 ж. дейін)
- «Неврология (ересектер)» мамандығы бойынша маман сертификаты (2030 ж. дейін)
- «Неврология (ересектер)» мамандығы бойынша жоғары біліктілік санаты (2030 ж. дейін)
- «Неврология (балалар)» мамандығы бойынша екінші біліктілік санаты (2030 ж. дейін)`,
  },
};
